import React, { useState, useContext } from "react";

import {
	Button,
	CssBaseline,
	TextField,
	Typography,
	InputAdornment,
	IconButton,
	Paper,
} from "@material-ui/core";

import { Visibility, VisibilityOff } from "@material-ui/icons";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";

import { makeStyles } from "@material-ui/core/styles";

import { i18n } from "../../translate/i18n";

import { AuthContext } from "../../context/Auth/AuthContext";

const useStyles = makeStyles((theme) => ({
	root: {
		minHeight: "100vh",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		padding: theme.spacing(2),
		background:
			theme.palette.type === "dark"
				? "radial-gradient(1200px 600px at 20% -10%, rgba(5,150,105,.25), transparent), #0B1220"
				: "radial-gradient(1200px 600px at 20% -10%, rgba(5,150,105,.12), transparent), #F1F5F9",
	},
	card: {
		width: "100%",
		maxWidth: 410,
		padding: theme.spacing(5, 4),
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		borderRadius: 20,
		border: `1px solid ${theme.custom.border}`,
	},
	brandIcon: {
		width: 52,
		height: 52,
		borderRadius: 14,
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		background: "linear-gradient(135deg, #10B981 0%, #059669 100%)",
		color: "#fff",
		marginBottom: theme.spacing(2),
		boxShadow: "0 8px 24px rgba(5,150,105,.35)",
	},
	title: {
		fontWeight: 800,
		letterSpacing: "-0.02em",
	},
	subtitle: {
		color: theme.palette.text.secondary,
		marginTop: 4,
		marginBottom: theme.spacing(3),
		fontSize: "0.9rem",
	},
	form: {
		width: "100%",
	},
	submit: {
		margin: theme.spacing(3, 0, 2),
		padding: "12px 0",
		fontSize: "0.95rem",
	},
	copyright: {
		marginTop: theme.spacing(1),
		fontSize: "0.75rem",
		color: theme.custom.textSecondary,
	},
}));

const Login = () => {
	const classes = useStyles();

	const [user, setUser] = useState({ email: "", password: "" });
	const [showPassword, setShowPassword] = useState(false);

	const { handleLogin } = useContext(AuthContext);

	const handleChangeInput = (e) => {
		setUser({ ...user, [e.target.name]: e.target.value });
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		handleLogin(user);
	};

	return (
		<div className={classes.root}>
			<CssBaseline />
			<Paper className={classes.card} elevation={0}>
				<div className={classes.brandIcon}>
					<WhatsAppIcon />
				</div>
				<Typography component="h1" variant="h5" className={classes.title}>
					Flytec
				</Typography>
				<Typography className={classes.subtitle}>
					Atendimento via WhatsApp para sua equipe
				</Typography>
				<form className={classes.form} noValidate onSubmit={handleSubmit}>
					<TextField
						variant="outlined"
						margin="normal"
						size="medium"
						required
						fullWidth
						id="email"
						label={i18n.t("login.form.email")}
						name="email"
						value={user.email}
						onChange={handleChangeInput}
						autoComplete="email"
						autoFocus
					/>
					<TextField
						variant="outlined"
						margin="normal"
						size="medium"
						required
						fullWidth
						name="password"
						label={i18n.t("login.form.password")}
						id="password"
						value={user.password}
						onChange={handleChangeInput}
						autoComplete="current-password"
						type={showPassword ? "text" : "password"}
						InputProps={{
							endAdornment: (
								<InputAdornment position="end">
									<IconButton
										aria-label="toggle password visibility"
										onClick={() => setShowPassword((e) => !e)}
									>
										{showPassword ? <VisibilityOff /> : <Visibility />}
									</IconButton>
								</InputAdornment>
							),
						}}
					/>
					<Button
						type="submit"
						fullWidth
						variant="contained"
						color="primary"
						className={classes.submit}
					>
						{i18n.t("login.buttons.submit")}
					</Button>
				</form>
				<Typography className={classes.copyright}>
					{`© ${new Date().getFullYear()} Flytec`}
				</Typography>
			</Paper>
		</div>
	);
};

export default Login;
